module.exports = __webpack_public_path__ + "img/project1_1.png.267028a5.webp";